/* Vitelli Moda — variant picker + size guide behaviour (2026-09-25).
   Mirrors Asternord: the "Name: Value" label follows the selection; the size-guide link opens one
   popup with an Uomo / Donna switch and garment tabs. Price, media, URL and availability stay with
   Sense's <variant-radios> (assets/global.js) — nothing here touches them.
   Markup: snippets/product-variant-picker.liquid, snippets/vm-size-guide.liquid. */
(function () {
  if (window.__vmVariantPicker) return;
  window.__vmVariantPicker = true;

  /* ---- "Colore: Verde militare" follows the selection ------------------------------------
     Reads the text inside the chosen label rather than input.value, so a market whose labels were
     translated in the page (T-Lab) shows the translated name. */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'radio') return;
    var row = input.closest('.vm-opt');
    if (!row) return;
    var out = row.querySelector('[data-vm-value]');
    if (!out) return;
    var label = row.querySelector('label[for="' + input.id + '"]');
    var text = label ? label.querySelector('[data-vm-text]') : null;
    out.textContent = text && text.textContent.trim() ? text.textContent.trim() : input.value;
  });

  /* ---- cm / in ---------------------------------------------------------------------------
     Only cells the server marked data-vm-cm convert (columns whose header ended in "(cm)"), so size
     labels such as "38" or "43/44" never change. Each number in a cell converts on its own, which
     covers ranges like "66–81". The shopper's choice is remembered in this browser only; without
     storage the popup simply opens on the default (inches in the US, cm elsewhere). */
  var UNIT_KEY = 'vm-sg-unit';

  function readUnit() {
    try { return window.localStorage.getItem(UNIT_KEY); } catch (err) { return null; }
  }
  function saveUnit(u) {
    try { window.localStorage.setItem(UNIT_KEY, u); } catch (err) { /* storage blocked: fine */ }
  }

  function toInches(text, dec) {
    return text.replace(/\d+(?:[.,]\d+)?/g, function (n) {
      var cm = parseFloat(n.replace(',', '.'));
      if (isNaN(cm)) return n;
      var inch = (Math.round((cm / 2.54) * 10) / 10).toFixed(1);
      return dec === ',' ? inch.replace('.', ',') : inch;
    });
  }

  function setUnit(dlg, unit) {
    if (!dlg) return;
    var dec = dlg.getAttribute('data-vm-dec') || '.';
    var cells = dlg.querySelectorAll('[data-vm-cm]');
    var i;
    for (i = 0; i < cells.length; i++) {
      var cm = cells[i].getAttribute('data-vm-cm');
      cells[i].textContent = unit === 'in' ? toInches(cm, dec) : cm;
    }
    var units = dlg.querySelectorAll('[data-vm-u]');
    for (i = 0; i < units.length; i++) units[i].textContent = unit === 'in' ? '(in)' : '(cm)';
    var line = dlg.querySelector('[data-vm-measures]');
    if (line) line.textContent = line.getAttribute(unit === 'in' ? 'data-in-text' : 'data-cm-text');
    var btns = dlg.querySelectorAll('[data-vm-unit]');
    for (i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', btns[i].getAttribute('data-vm-unit') === unit ? 'true' : 'false');
    }
    dlg.setAttribute('data-unit', unit);
  }

  function initUnits() {
    var stored = readUnit();
    var dlgs = document.querySelectorAll('dialog.vm-sg');
    for (var i = 0; i < dlgs.length; i++) {
      var u = stored === 'cm' || stored === 'in' ? stored : dlgs[i].getAttribute('data-vm-unit-default') || 'cm';
      setUnit(dlgs[i], u);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initUnits);
  else initUnits();

  /* ---- size guide popup ------------------------------------------------------------------ */
  var opener = null;

  function lock(on) {
    document.documentElement.classList.toggle('vm-sg-lock', on);
  }

  function showCat(set, cat) {
    if (!set) return;
    var tabs = set.querySelectorAll('[data-vm-sgt]');
    var have = false;
    var i;
    for (i = 0; i < tabs.length; i++) if (tabs[i].getAttribute('data-vm-sgt') === cat) have = true;
    if (!have && tabs.length) cat = tabs[0].getAttribute('data-vm-sgt');
    for (i = 0; i < tabs.length; i++) {
      tabs[i].setAttribute('aria-selected', tabs[i].getAttribute('data-vm-sgt') === cat ? 'true' : 'false');
    }
    var panels = set.querySelectorAll('[data-vm-sgp]');
    for (i = 0; i < panels.length; i++) panels[i].hidden = panels[i].getAttribute('data-vm-sgp') !== cat;
    set.setAttribute('data-cat', cat);
  }

  function showGender(root, g) {
    var btns = root.querySelectorAll('[data-vm-sgg]');
    var i;
    for (i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', btns[i].getAttribute('data-vm-sgg') === g ? 'true' : 'false');
    }
    var sets = root.querySelectorAll('[data-vm-sgset]');
    for (i = 0; i < sets.length; i++) {
      var on = sets[i].getAttribute('data-vm-sgset') === g;
      sets[i].hidden = !on;
      if (on) showCat(sets[i], sets[i].getAttribute('data-cat') || root.getAttribute('data-cat') || '1');
    }
    root.setAttribute('data-gender', g);
  }

  function open(dlg, from) {
    opener = from || null;
    if (typeof dlg.showModal === 'function') {
      if (!dlg.open) dlg.showModal();
    } else {
      dlg.setAttribute('open', '');
    }
    lock(true);
    var content = dlg.querySelector('.vm-sg__content');
    if (content) content.scrollTop = 0;
  }

  // Unlocks synchronously on every path; the native 'close' event is async and is not a safe
  // place to hang the scroll lock on (it can be deferred, and never fires if open() failed).
  function release() {
    lock(false);
    var back = opener;
    opener = null;
    if (back && typeof back.focus === 'function') {
      try { back.focus({ preventScroll: true }); } catch (err) { back.focus(); }
    }
  }

  function close(dlg) {
    if (typeof dlg.close === 'function' && dlg.open) dlg.close();
    else dlg.removeAttribute('open');
    release();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var trigger = t.closest('[data-vm-sg-open]');
    if (trigger) {
      var dlg = document.getElementById(trigger.getAttribute('data-vm-sg-open'));
      if (dlg) {
        e.preventDefault();
        open(dlg, trigger);
      }
      return;
    }

    var dialog = t.closest('dialog.vm-sg');
    if (!dialog) return;

    // the dialog element itself only receives clicks on its backdrop (the box fills it)
    if (t === dialog || t.closest('[data-vm-sg-close]')) {
      close(dialog);
      return;
    }

    var unitBtn = t.closest('[data-vm-unit]');
    if (unitBtn) {
      e.preventDefault();
      var u = unitBtn.getAttribute('data-vm-unit');
      saveUnit(u);
      // keep every popup on the page in step (a featured-product section can add a second one)
      var all = document.querySelectorAll('dialog.vm-sg');
      for (var k = 0; k < all.length; k++) setUnit(all[k], u);
      return;
    }

    var sw = t.closest('[data-vm-sgg],[data-vm-sgt]');
    if (!sw) return;
    var root = sw.closest('[data-vm-sg]');
    if (!root) return;
    e.preventDefault();
    if (sw.hasAttribute('data-vm-sgg')) showGender(root, sw.getAttribute('data-vm-sgg'));
    else showCat(sw.closest('[data-vm-sgset]'), sw.getAttribute('data-vm-sgt'));
  });

  // Esc: 'cancel' fires synchronously before the browser closes the dialog. 'close' is a backstop
  // for any other way the dialog gets closed. Neither bubbles, so both listen in the capture phase.
  function onDialogEnd(e) {
    if (!e.target || !e.target.matches || !e.target.matches('dialog.vm-sg')) return;
    if (document.documentElement.classList.contains('vm-sg-lock')) release();
  }
  document.addEventListener('cancel', onDialogEnd, true);
  document.addEventListener('close', onDialogEnd, true);
})();
